import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import MultiTextField from "../../../Components/common/MultiTextField";
import { ContractTypeOptions } from "./constants";
import { ExdPrimaryButton } from "./ExdControls";
import { EXD, widgetSx } from "./exdMui";

const ContractTypeFilterBar = ({
  selectedContractTypes,
  onChange,
  onSearch,
  translate,
}) => (
  <Paper
    elevation={0}
    component="header"
    sx={{
      ...widgetSx(),
      alignItems: "center",
      border: "1px solid #e3e5ee",
      boxShadow: "none",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: 1.5,
      justifyContent: "space-between",
      px: 1.75,
      py: 1.25,
      width: "100%",
    }}
  >
    <Box sx={{ minWidth: 0, pr: 1 }}>
      <Typography
        component="h1"
        sx={{
          color: "#1b1f4b",
          fontSize: 16,
          fontWeight: 700,
          letterSpacing: "-0.01em",
          lineHeight: 1.25,
          m: 0,
        }}
      >
        {translate("ex_dashboard")}
      </Typography>
      <Typography
        sx={{
          color: "#646a8a",
          fontSize: 12,
          fontWeight: 500,
          lineHeight: 1.35,
          mt: 0.25,
          maxWidth: 520,
        }}
      >
        {translate("ex_dashboard_purpose") ||
          "Executive overview of sales, operations, collections, and account performance."}
      </Typography>
    </Box>

    <Stack
      direction="row"
      alignItems="flex-end"
      flexWrap="wrap"
      spacing={1}
      useFlexGap
      sx={{ ml: "auto" }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.375, minWidth: 220, width: 260 }}>
        <Typography
          component="label"
          htmlFor="contractType"
          sx={{ color: EXD.muted, fontSize: 10, fontWeight: 600 }}
        >
          {translate("contractType")}
        </Typography>
        <MultiTextField
          id="contractType"
          select
          label=""
          value={selectedContractTypes}
          onChange={onChange}
          margin="none"
          fullWidth
          required
          multiSelect
          options={ContractTypeOptions}
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.375 }}>
        <Typography component="label" sx={{ fontSize: 10, visibility: "hidden" }}>
          &nbsp;
        </Typography>
        <ExdPrimaryButton
          disabled={!selectedContractTypes.length}
          onClick={onSearch}
        >
          {translate("search")}
        </ExdPrimaryButton>
      </Box>
    </Stack>
  </Paper>
);

export default ContractTypeFilterBar;
